/* @flow */
import React from 'react';
import { Route } from 'react-router';

import GroupsView from 'groups/components/GroupsView.jsx';
import OrganizationContainer from 'organizations/components/OrganizationContainer.jsx';

export default (
  <Route path="/organizations(/)" component={GroupsView} onEnter={GroupsView.onEnter}>
    <Route path=":organizationId" component={OrganizationContainer} />
  </Route>
);



// WEBPACK FOOTER //
// ./src/organizations/routes.js